export default class ParametroSolicitudReporteCrediticio {
    constructor(){
        this.Identificacion = "";
        this.TipoPersona= 0;
        this.TipoReporte= 0;
        this.IpCliente = "";
        this.IdentificacionUsuario = "";
        this.EntidadUsuario = "";
    }
    
    Identificacion: string;
    TipoPersona: number;
    TipoReporte: number;
    IpCliente: string;
    IdentificacionUsuario: string;
    EntidadUsuario: string;
}